import React from 'react'
import './LinkBlocksImg.css'
import Lightbox from 'react-images'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import ButtonLeft from './ButtonLeft'


class LinkBlocksImg extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    }

    this.openLightbox = this.openLightbox.bind(this)
    this.gotoPrevious = this.gotoPrevious.bind(this)
    this.gotoNext = this.gotoNext.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this)
  }

  openLightbox (index, event) {
		event.preventDefault()
		this.setState({	currentImage: index, lightboxIsOpen: true	})
	}

  gotoPrevious() {
    this.setState({	currentImage: this.state.currentImage - 1 })
  }

  gotoNext() {
    this.setState({	currentImage: this.state.currentImage + 1 })
  }

  closeLightbox() {
    this.setState({ lightboxIsOpen: false	})
  }

  render() {
    return (
      <ReactCSSTransitionGroup
      transitionName="imgTransition"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionEnter={false}
      transitionLeave={false}>
      <div className="mainWrap">
        <div className="mainBlock">
          <ButtonLeft url={this.props.url} />
          <div>
{ this.props.children }
          </div>
        </div>
        <div className="galery">
          { this.props.itemsmin.map( (item, index) => 
            <img key={index} onClick={(event) => this.openLightbox(index, event)} src={item} alt=""/> ) }
        </div>
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.itemsfull}
          isOpen={this.state.lightboxIsOpen}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          onClose={this.closeLightbox} />
      </div>
      </ReactCSSTransitionGroup>
    )
  } 
}

export default LinkBlocksImg


// WEBPACK FOOTER //
// ./src/components/LinkBlocksImg.jsx